import { useFetchData } from "../../../hooks/useFetch";
import { ApiConfig } from "../../../services/api-config";
import { API_SHIFT_ROUTER } from "../../../services/api-config";

export enum ShiftStatusCode {
  INACTIVE = 2,
  ACTIVE = 1,
}

export interface ShiftListFilters {
  status?: number; // 1 active, 0 inactive, -1 all
  keyword?: string;
  department_id?: number;
  is_user?: number;
}

export interface Shift {
    id: string; 
    name: string;
    code: string;
    start_time: string; // HH:mm
    end_time: string; // HH:mm
    break_time: number;
    max_employees: number;
    status: number;
    description: string;
    normalize_name: string;
    created_at: string;
    updated_at: string;
}

export interface ShiftListResponse {
  list: Shift[];
  total_record?: number;
  limit?: number;
}

export interface CreateShiftPayload {
  name: string;
  code: string;
  start_time: string;
  end_time: string;
  description: string;
}

export interface UpdateShiftPayload {
  name: string;
  code: string;
  start_time: string;
  end_time: string;
  description: string;
}

export interface ChangeStatusPayload {
  status: ShiftStatusCode;
  /** Xác nhận xoá các lượt gán ca từ ngày mai trở đi khi tạm ngưng ca đang được gán. */
  confirm?: boolean;
}

/** BE trả status này khi tạm ngưng ca còn lượt gán trong tương lai — cần người dùng xác nhận lại. */
export const SHIFT_REQUIRES_CONFIRM_STATUS = 409;


const ShiftService = {
  list: () => {
    const { request, baseResponse, loading } = useFetchData.Get<ShiftListResponse>({
      projectId: ApiConfig.PROJECT_ID.HRM_SERVICE,
    });
    return {
      fetch: (params: ShiftListFilters = { status: -1 }) =>
        request({
          endPoint: API_SHIFT_ROUTER.API_LIST,
          data: params,
        }),
      response: baseResponse,
      loading: loading,
    }
  },
  create: () => {
    const { request, baseResponse, loading } = useFetchData.Post<Shift>({
      projectId: ApiConfig.PROJECT_ID.HRM_SERVICE,
    });
    return {
      fetch: (payload: CreateShiftPayload) =>
        request({
          endPoint: API_SHIFT_ROUTER.API_CREATE,
          data: payload,
        }),
      response: baseResponse,
      loading: loading,
    }
  },
  update: () => {
    const { request, baseResponse, loading } = useFetchData.Post<Shift>({
      projectId: ApiConfig.PROJECT_ID.HRM_SERVICE,
    });
    return{
      fetch: (id: number, payload: UpdateShiftPayload) =>
        request({
          endPoint: API_SHIFT_ROUTER.API_UPDATE(id),
          data: payload,
        }),
      response: baseResponse,
      loading: loading
    }
  },
  changeStatus: () => {
      const { request, baseResponse, loading } = useFetchData.Post<Shift>({
        projectId: ApiConfig.PROJECT_ID.HRM_SERVICE,
      });
      return {
        fetch: (id: number, payload: ChangeStatusPayload) =>
          request({
            endPoint: API_SHIFT_ROUTER.API_CHANGE_STATUS(id),
            data: payload,
          }),
        response: baseResponse,
        loading: loading,
      }
    },
}

export default ShiftService;